export const currency: string ="POL";
export const token: string ="TCK";
export const wiki: string ="https://whitepaper.catfarmcrypto.com/";
export const quickswap: string ="https://quickswap.exchange/#/swap?currency0=ETH&currency1=0xC9dF8aEEaE1Ac0FF056c0c37FC4F1d97033363D5&swapIndex=0";
// import { currency,token,wiki } from '../../../constants';
